// src/components/lead/sections/help/LeadsHelp.tsx

export function LeadsHelp({
  salesperson,
  location,
  appDisplayName,
}: {
  salesperson: { name: string } | null;
  location: { name: string } | null;
  appDisplayName: string;
}) {
  if (!location) {
    return (
      <ul className="list-disc list-inside text-blue-900 space-y-1">
        <li>
          Choose your working lot in the profile/location selector. If your org has only one assigned lot, it may be selected
          automatically when locations load.
        </li>
        <li>If no lot choices appear, ask an admin to assign your account to a location.</li>
        <li>Your name comes from your signed-in account{salesperson?.name ? ` (${salesperson.name})` : ""}.</li>
      </ul>
    );
  }

  return (
    <ul className="list-disc list-inside text-blue-900 space-y-1">
      <li>
        Tap <strong>New Customer</strong>, then <strong>Listen</strong>, and talk normally.
      </li>
      <li>{appDisplayName} listens in chunks and fills the lead summary.</li>
      <li>Fix name, phone, email, etc. in the summary if needed.</li>
      <li>
        When it looks good, tap <strong>Send to CRM</strong>.
      </li>
    </ul>
  );
}
